import { Link } from "react-router-dom";

export const LegalLinks = () => {
    return (
        <div className="flex gap-x-4 flex-wrap justify-center gap-y-2 bg-white border-t-2 py-3 text-primaryNewComparateurFibre md:flex-row md:gap-x-4 w-full items-center">
          <Link to="/gestion_des_cookies" target="_blank">Gestion des cookies</Link>
          <Link to="/politique_de_confidentialite" target="_blank">Politique de confidentialité</Link>
          <Link to="/conditions_generales_utilisation" target="_blank">Conditions générales d'utilisation</Link>
        </div>
    );
};
